import { toast } from '../components/toast';
import { t } from '../i18n';
import { setTalk, useMedia } from '../live/media';
import { robotName } from '../live/store';

/** Toggle publishing the browser microphone into a robot's LiveKit room, with user-facing errors. */
export async function talk(serial: string, on: boolean): Promise<boolean> {
  try {
    const ok = await setTalk(serial, on);
    if (!ok && on) toast(t('talk.notConnected', { name: robotName(serial) }), 'err');
    return ok;
  } catch (e) {
    toast(t('talk.micError', { msg: (e as Error).message }), 'err');
    return false;
  }
}

export const isTalking = (serial: string) => Boolean(useMedia.getState().byRobot[serial]?.talking);
